import { render, staticRenderFns } from "./tg4.vue?vue&type=template&id=d85f68dc&scoped=true&"
import script from "./tg4.vue?vue&type=script&lang=js&"
export * from "./tg4.vue?vue&type=script&lang=js&"
import style0 from "./tg4.vue?vue&type=style&index=0&id=d85f68dc&prod&lang=scss&scoped=true&"
import style1 from "./tg4.vue?vue&type=style&index=1&id=d85f68dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85f68dc",
  null
  
)

export default component.exports